export const actionType = {
    ADDDELIVERY_REQUEST: 'ADDDELIVERY_REQUEST',
    ADDDELIVERY_SUCCESS: 'ADDDELIVERY_SUCCESS',
    ADDDELIVERY_FAILURE: 'ADDDELIVERY_FAILURE', 
};